import { Link, useLocation } from 'react-router-dom';
import { AppleIcon } from '../icons';
import { Wordmark } from './Wordmark';

export function Nav() {
  const { pathname } = useLocation();
  const onLanding = pathname === '/';
  const hashLink = (id: string) => (onLanding ? `#${id}` : `/#${id}`);

  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Link className="wordmark" to="/" aria-label="Cranio — home">
          <Wordmark />
        </Link>
        <div className="nav-links">
          <a className="link" href={hashLink('features')}>Studio</a>
          <a className="link" href={hashLink('models')}>Models</a>
          <a className="link" href={hashLink('pricing')}>Pricing</a>
          <Link className="link" to="/contact">Contact</Link>
        </div>
        <div className="nav-cta">
          <a className="btn btn-solid" href={hashLink('download')}>
            <AppleIcon /> Download
          </a>
        </div>
      </div>
    </nav>
  );
}
